<template>
  <div class="calculate-products">
    <div :class="{'product-group-container': true, 'no-scroll': isNoScroll()}">
      <div class="product-group-arrow product-group-arrow-left" @click="moveLeftProductGroups($event)">
        <i class="fa fa-chevron-left" />
      </div>
      <div class="product-groups">
        <div class="group-tabs">
          <div v-for="(grp, grpIndex) in productsGroups" v-show="(!shared && (!showSelected || getSelectedCountInGroup(grp.data) > 0)) || (shared && getSelectedCountInGroup(grp.data) > 0)" :key="'products-group-' + grpIndex" :class="{'group-tab': true, 'selected': grp.grpCode === selectedGroup}">
            <div v-if="(!shared && (!showSelected || getSelectedCountInGroup(grp.data) > 0)) || (shared && getSelectedCountInGroup(grp.data) > 0)" class="product-group" @click="selectGroup(grp.grpCode)">
              <img v-if="grp.grpCode === selectedGroup" src="/img/calculator/ic_tile_logo_white.png" alt="Unistars" class="unistars-logo">
              <img v-else src="/img/calculator/ic_tile_logo_blue.png" alt="Unistars" class="unistars-logo">
              <span class="first-character">{{ $t('code.nm.' + grp.grpCode).substring(0, 1) }}</span><span class="remained-character">{{ $t('code.nm.' + grp.grpCode).substring(1) }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="product-group-arrow product-group-arrow-right" @click="moveRightProductGroups($event)">
        <i class="fa fa-chevron-right" />
      </div>
    </div>
    <div v-for="(grp, grpIndex) in productsGroups" :key="'products-group-' + grpIndex">
      <div v-if="selectedGroup === grp.grpCode" class="product-group">
        <div v-for="(product, productIndex) in grp.data" :key="'product-' + productIndex">
          <div v-if="!showSelected || (product.co)" class="product">
            <div class="dot" />
            <div class="product-title">
              {{ product.nm }}
            </div>
            <div class="product-price">
              {{ product.pc | formatNumber }}
            </div>
            <div class="product-point">
              <div v-if="hidePointFlag === 'N'">
                {{ product.point | formatNumber }}P
              </div>
            </div>
            <div class="product-quantity">
              <div :class="{'plus':true, 'shared':shared}" :disabled="shared" @click="addProductCount(product, $event)">
                +
              </div>
              <div class="quantity">
                {{ product.co ? product.co : 0 }}
              </div>
              <div :class="{'minus':true, 'shared':shared}" :disabled="shared" @click="subtractProductCount(product, $event)">
                -
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      ref="imageSliderRef"
      :title="targetProduct.nm"
      modal-class="simple-design dark-background-modal"
      ok-only
      centered
      :ok-title="$t('product.text.description')"
      @shown="onImageSliderShown"
      @ok="openURL(targetProduct.url, '_blank')"
    >
      <div v-if="productImages" class="image-slider-area">
        <image-slider3d :contents="productImages" :width="800" />
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    shared: {
      type: Boolean,
      default: false
    },
    showSelected: {
      type: Boolean,
      default: false
    },
    hidePointFlag: {
      type: String,
      default: 'N'
    },
    groups: {
      type: Array,
      default: undefined
    },
    products: {
      type: Array,
      default: undefined
    }
  },
  data() {
    return {
      productsGroups: undefined,
      productImages: [],
      targetProduct: {},
      selectedGroup: undefined
    }
  },
  watch: {
    groups: {
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          this.$forceUpdate()
        })
      },
      deep: true,
      immediate: true
    },
    productsGroups: {
      handler(newVal, oldVal) {
        if (!this.selectedGroup && newVal && newVal.length) {
          this.selectedGroup = newVal[0].grpCode
        }
        this.$nextTick(() => {
          this.$forceUpdate()
        })
      },
      deep: true,
      immediate: true
    }
  },
  async mounted() {
    if (this.groups) {
      this.productsGroups = this.groups
    }
    if (!this.productsGroups) {
      const res = await this.$axios.$get('/prduct/public/products', {
        no_loading: true
      })
      this.productsGroups = res.data
    }
    if (this.products) {
      this.updateProductCounts()
    } else {
      this.$emit('initiated', this.productsGroups)
      this.$emit('updated', this.productsGroups)
    }
  },
  methods: {
    isNoScroll() {
      if ($('.group-tabs').length === 0) {
        return true
      }
      return $('.product-groups').width() > $('.group-tabs').width()
    },
    moveLeftProductGroups(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      $('.product-groups').animate({
        scrollLeft: $('.product-groups').scrollLeft() - 100
      })
    },
    moveRightProductGroups(e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      $('.product-groups').animate({
        scrollLeft: $('.product-groups').scrollLeft() + 100
      })
    },
    selectGroup(grpCode) {
      this.selectedGroup = grpCode
    },
    updateCounts(param) {
      this.productsGroups = param
      if (this.products) {
        this.updateProductCounts()
      } else {
        this.$emit('initiated', this.productsGroups)
        this.$emit('updated', this.productsGroups)
      }
      this.$forceUpdate()
    },
    onImageSliderShown() {
      this.productImages = this.targetProduct.image
      this.$forceUpdate()
    },
    showImageSlider(product, e) {
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      this.productImages = undefined
      this.showModal('imageSliderRef')
      this.targetProduct = product
    },
    updateProductCounts() {
      if (!this.productsGroups) {
        return
      }
      for (let i = 0; i < this.productsGroups.length; i++) {
        const grp = this.productsGroups[i]
        for (let j = 0; j < grp.data.length; j++) {
          const product = grp.data[j]
          product.co = 0
          if (this.products) {
            for (let k = 0; k < this.products.length; k++) {
              if (this.products[k].id === product.id) {
                product.co = this.products[k].co
              }
            }
          }
        }
      }
      this.$emit('initiated', this.productsGroups)
      this.$emit('updated', this.productsGroups)
      this.$forceUpdate()
    },
    getSelectedProducts() {
      const products = []
      if (!this.productsGroups) {
        return products
      }
      for (let i = 0; i < this.productsGroups.length; i++) {
        const grp = this.productsGroups[i]
        for (let j = 0; j < grp.data.length; j++) {
          const product = grp.data[j]
          if (product.co) {
            products.push(product)
          }
        }
      }
      return products
    },
    getSelectedCountInGroup(data) {
      if (!data || data.length === 0) {
        return 0
      }
      let ret = 0
      for (let i = 0; i < data.length; i++) {
        const datum = data[i]
        if (datum.co) {
          ret += datum.co
        }
      }
      return ret
    },
    addProductCount(product, e) {
      if (this.shared) {
        return
      }
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      if (!product.co) {
        product.co = 0
      }
      product.co++
      this.$forceUpdate()
      this.$emit('updated', this.productsGroups)
    },
    subtractProductCount(product, e) {
      if (this.shared) {
        return
      }
      if (e) {
        if (e.preventDefault) {
          e.preventDefault()
        }
        if (e.stopPropagation) {
          e.stopPropagation()
        }
      }
      this.vibrate(e)
      if (!product.co) {
        return
      }
      product.co--
      this.$forceUpdate()
      this.$emit('updated', this.productsGroups)
    }
  }
}
</script>

<style scoped>
.calculate-products {
  background: #ffffff;
  padding: 0 1.6083rem 5.5416rem;
}
.group-title {
  color: #360ea6;
  font-weight: bold;
  font-size: 1.3333rem;
  margin-bottom: 0.4rem;
}
.group-title .first-character {
  font-size: 1.3333rem;
}
.group-title .remained-character {
  letter-spacing: 0.04rem;
}
.product-group-container {
  display: flex;
}
.product-group-arrow {
  width: 1.5rem;
  padding: 0.4rem 0;
  color: #999999;
}
.product-group-arrow-left {
  text-align: left;
}
.product-group-arrow-right {
  text-align: right;
}
.product-groups {
  position: relative;
  width: calc(100% - 3rem);
  overflow-x: auto;
}
.no-scroll .product-groups {
  width: 100%;
}
.no-scroll .product-group-arrow {
  display: none;
}
.product {
  display: flex;
  align-items: center;
  min-height: 4.6666rem;
  border-bottom: 1px solid #ececec;
}
.product-image img {
  width: 3.48333rem;
  margin: 0 1rem;
  background-color: rgb(13, 71, 161, 0.1);
}
.product .dot {
  width: 0.608333333333333rem;
  height: 0.608333333333333rem;
  background: #360ea6;
  border-radius: 50%;
  margin-right: 1rem;
}
.product-title {
  font-size: 1rem;
  color: #2c2c2c;
  width: calc(100vw - 18.5rem);
  overflow: hidden;
  text-overflow: ellipsis;
}
.product-price,
.product-point {
  font-size: 1rem;
  color: #360ea6;
  text-align: center;
  width: 4rem;
}
.product-quantity .plus {
  border-top-left-radius: 0.1rem;
  border-bottom-left-radius: 0.1rem;
  border-right: none !important;
}
.product-quantity .minus {
  border-top-right-radius: 0.1rem;
  border-bottom-right-radius: 0.1rem;
  border-left: none !important;
}
.product-quantity .quantity,
.product-quantity .plus,
.product-quantity .minus {
  width: 1.8333rem;
  height: 1.458rem;
  border: 1px solid #bebebe;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.1rem 0 0;
}
.product-quantity {
  display: flex;
  align-items: center;
}
.product-quantity .quantity {
  font-size: 0.8333rem;
}
.product-quantity .plus,
.product-quantity .minus {
  color: #015b97;
  font-size: 1.3rem;
}
.group-tabs::-webkit-scrollbar {
  display: none;
}
.group-tabs {
  width: fit-content;
  display: flex;
  overflow: auto;
}
.group-tab {
  height: 2.233333333333333rem;
  border-radius: 1.108333333333333rem;
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #360ea6;
  justify-content: center;
  padding: 0 1.941666666666667rem;
}
.group-tab.selected {
  background: #360ea6;
  color: white;
}
.unistars-logo {
  width: 1.025rem;
  margin-right: 0.6rem;
}
.product-groups::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera*/
}
</style>
